import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["calendarPage", "id", "locale", "onCalendarPageChange", "onActiveBoundChange", "today", "value"];
import unescapedText from 'I18n/utils/unescapedText';
import { toMoment } from '../../../utils/SimpleDate';
import { syntheticEvent } from '../../../utils/SyntheticEvent/SyntheticEvent';
import styled from 'foundations-theming/utils';
import { MonthWithRange } from './MonthWithRange';
import { LeftIcon, RightIcon } from 'foundations-assets';
import { StyledButton, StyledButtonTextContainer } from '../../Button/PrivateButton';
import { getLocaleData } from '../../../utils/Locale';
import { getPageFromDate, nextCalendarPage, prevCalendarPage } from '../../../utils/calendarUtils';
import { IconButton } from '../../IconButton/IconButton';
import { ScreenReaderOnly } from '../../ScreenReaderOnly';
import { callIfPossible } from '../../../utils/functions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "CalendarPageWithRange__Wrapper",
  componentId: "sc-1yz3iyf-0"
})(() => {
  return {
    display: 'inline-block',
    [`${StyledButton}`]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    [`${StyledButtonTextContainer}`]: {
      inlineSize: '22px',
      blockSize: '22px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& svg': {
        inlineSize: '22px',
        blockSize: '22px'
      }
    }
  };
});

/**
 * @param date
 * @returns A string for announcing the given date to screen readers
 */
const getSpokenDate = date => date ? toMoment(date).format('LL') : unescapedText('ui.datePicker.noDateSelected');

/**
 * @param value The current selected range
 * @returns A string for announcing the selected date range to screen readers
 */
const getAlertText = value => `${unescapedText('ui.dateRange.startDate')}: ${getSpokenDate(value === null || value === void 0 ? void 0 : value.startDate)}` + `, ${unescapedText('ui.dateRange.endDate')}: ${getSpokenDate(value === null || value === void 0 ? void 0 : value.endDate)}`;
export const CalendarPageWithRange = _ref => {
  let {
      calendarPage,
      id,
      locale,
      onCalendarPageChange,
      onActiveBoundChange,
      today,
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const localeData = getLocaleData(locale);
  const currentCalendarPage = calendarPage || getPageFromDate((value === null || value === void 0 ? void 0 : value.startDate) || today);
  if (!currentCalendarPage) {
    return null;
  }
  const {
    month,
    year
  } = currentCalendarPage;
  return /*#__PURE__*/_jsxs(Wrapper, {
    id: id,
    children: [/*#__PURE__*/_jsx(ScreenReaderOnly, {
      "aria-live": "polite",
      "aria-atomic": true,
      children: getAlertText(value)
    }), /*#__PURE__*/_jsx(MonthWithRange, Object.assign({}, rest, {
      onActiveBoundChange: onActiveBoundChange,
      month: month,
      leftControl: /*#__PURE__*/_jsx(IconButton, {
        "data-action": "prev-month",
        use: "transparent",
        "aria-label": unescapedText('ui.datePicker.prevMonth'),
        onClick: () => {
          callIfPossible(onCalendarPageChange, syntheticEvent(prevCalendarPage(currentCalendarPage)));
        },
        children: /*#__PURE__*/_jsx(LeftIcon, {})
      }),
      ownerId: id,
      rightControl: /*#__PURE__*/_jsx(IconButton, {
        "data-action": "next-month",
        use: "transparent",
        "aria-label": unescapedText('ui.datePicker.nextMonth'),
        onClick: () => {
          callIfPossible(onCalendarPageChange, syntheticEvent(nextCalendarPage(currentCalendarPage)));
        },
        children: /*#__PURE__*/_jsx(RightIcon, {})
      }),
      today: today,
      weekdayHeadings: localeData.weekdaysMin(),
      weekStartDay: localeData.firstDayOfWeek(),
      value: value,
      year: year
    }))]
  });
};